import React from "react";
// React Router
import { useHistory } from "react-router-dom";
// Styled Components
import styled from "styled-components";
// Componentes
import VerticalCard from "../generic/VerticalCard";
// React bootraps
import { Button } from "react-bootstrap";

const CardProvincia = styled(VerticalCard).attrs(props => ({

  backgroundColor: props.accesible ? "#F0F8FF" : "#FFF0F0",
  grayscale: props.active ? 0 : 100,
  shadow: props.active ? "0 0px 6px #2a599f !important" : "0 0px 6px #93a1b4 !important"

}))`
-webkit-filter: grayscale(${props => props.grayscale}); /* Safari 6.0 - 9.0 */
filter: grayscale(${props => props.grayscale});

  width: 37rem;
  :hover {
    box-shadow: 0 0px 6px #2a599f !important;
    background-color: ${props => props.backgroundColor};
  }
`;

const obtenerPermiso = (userLevel, provinceLogueadoId, provinceIdActual, mayor) => {
  return mayor ? 
    (((userLevel === 9 || userLevel === 8) && provinceLogueadoId === provinceIdActual) || userLevel > 9) ? true : false
    :
    (((userLevel === 9 || userLevel === 8) && provinceLogueadoId === provinceIdActual) || (userLevel !== 9 && userLevel !== 8)) ? true : false
}

const ProvinciaTarjeta = ({ content, provinciaLogueado, ...props }) => {
  let history = useHistory();
  let defaultImg = "/images/logoSTJ.png";
  let img = content.photo ? `${process.env.REACT_APP_API_URL}/download/provincias/${content.id}` : "/images/logoSTJ.png";

  // TODO e.stopPropagation
  let botonComunidades = (
    <Button
      disabled={!obtenerPermiso(props.userLevel, provinciaLogueado.id, content.id, false)}
      onClick={(e) => {
        history.push(`provincias/${content.id}/comunidades`);
        e.stopPropagation();
      }}
      variant="outline-primary"
      className={"mr-1"}
    >
      Comunidades
    </Button>
  );

  let botonGruposDeTrabajo = props.userLevel >= 8 ? (
    <Button
      disabled={!obtenerPermiso(props.userLevel, provinciaLogueado.id, content.id, false)}
      onClick={(e) => {
        history.push(`provincias/${content.id}/gruposTrabajo`);
        e.stopPropagation();
      }}
      variant="outline-secondary"
      className={"mr-1"}
    >
      Equipos/Comisiones
    </Button>
  ) : null;
  let botonMision = (
    <Button
      disabled={!obtenerPermiso(props.userLevel, provinciaLogueado.id, content.id, false)}
      onClick={(e) => {
        history.push(`provincias/${content.id}/mision`);
        e.stopPropagation();
      }}
      variant="outline-info"
    >
      Misión
    </Button>
  );

  let buttons = [botonComunidades, botonGruposDeTrabajo, botonMision];

  return (
    <>
    {/*console.log(content)}
    {console.log(provinciaLogueado.id)}
  {console.log(props.userLevel)*/}
    <CardProvincia
      onClick={obtenerPermiso(props.userLevel, provinciaLogueado.id, content.id, true)?
                    ((e) => {history.push(`provincias/${content.id}`);}) 
                  :
                null
              }
      cardImage={img}
      title={content.name}
      imgOnError={defaultImg}
      buttons={buttons}
      active={!content.endDate}
      accesible={obtenerPermiso(props.userLevel, provinciaLogueado.id, content.id, true)}
      {...props}
    />
    </>
  );
};

export default ProvinciaTarjeta;
